import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';

import LoadingDashboardContent from '../components/LoadingDashboardContent';
import LoginModal from '../components/LoginModal';
import { useTokens } from '../context/TokenContext';
import { API_URL } from '../constants';

const ProtectedRouteAdmin = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);

  const { getItem, setItem, isTokenExpired } = useTokens();
  const token = getItem('admin', 'AuthToken');

  const loginUrl = `${API_URL}/admin/login`;
  const heartbeatUrl = `${API_URL}/heartbeat`;

  // Initial check: is token present and valid?
  useEffect(() => {
    const initAuthCheck = () => {
      if (!token || isTokenExpired(token)) {
        setIsAuthenticated(false);
        setShowModal(true);
      } else {
        setIsAuthenticated(true);
        setShowModal(false);
      }
      setLoading(false);
    };

    initAuthCheck();
  }, [token]);

  // Silent heartbeat check every 60s
  useEffect(() => {
    const checkHeartbeatSilently = async () => {
      try {
        const response = await axios.get(heartbeatUrl, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.data?.message !== 'Token is valid.') {
          console.warn('Heartbeat failed. Token may be invalid.');
        } else {
          setItem('admin', 'UserNotifications', response.data?.notifications || []);
        }
      } catch (err) {
        console.warn('Silent heartbeat error:', err);
      }
    };

    if (token) {
      checkHeartbeatSilently();
    }

    const interval = setInterval(() => {
      if (token) {
        checkHeartbeatSilently();
      }
    }, 60000);

    return () => clearInterval(interval);
  }, [token]);

  // Handle login success from modal
  const handleLoginSuccess = (newToken, user) => {
    setItem('admin', 'AuthToken', newToken);
    setItem('admin', 'UserInfo', user);
    setIsAuthenticated(true);
    setShowModal(false);
  };

  if (loading) return <LoadingDashboardContent />;

  return (
    <>
      {isAuthenticated && children}
      {showModal && (
        <LoginModal
          show={true}
          userType="admin"
          loginPath={loginUrl}
          onLogin={handleLoginSuccess}
        />
      )}
    </>
  );
};

export default ProtectedRouteAdmin;
